import ConfirmMobile from './ConfirmMobile';

export default ConfirmMobile;
